import React from "react"
import { Link } from "react-router-dom"
import path from "../../Assets/site2.jpg"
import AOS from "aos"
import "aos/dist/aos.css"
import { useEffect } from "react"

const pathPoints = [
	{ icon: "ri-shield-star-line",  color: "#8B6820", label: "Exclusive girls-focused career school" },
	{ icon: "ri-book-2-line",       color: "#C4935A", label: "Integrated NEET, JEE, KEAM, CUET coaching" },
	{ icon: "ri-heart-pulse-line",  color: "#174e4a", label: "Safe, supportive, and ambitious environment" },
	{ icon: "ri-user-star-line",    color: "#C4935A", label: "Strong mentorship & career guidance" },
	{ icon: "ri-global-line",       color: "#8B6820", label: "Global exposure and university pathways" },
]

const Path = () => {
	useEffect(() => {
		AOS.init({ disable: "phone", duration: 700 })
	}, [])

	return (
		<div className="path-section">
			<div className="container-main">
				<div className="row">
					<div className="col-lg-12">
						<h5 className="path-samll-text montserrat">Your Future Starts Here</h5>
						<h1 className="path-main-heading montserrat">Why Choose Le Fille <span className="montserrat path-main-block-text">Global School?</span></h1>
					</div>
					<div className="col-lg-6">
						<div className="path-image" data-aos="fade-right">
							<img src={path} className="path-image-main" alt="" />
						</div>
					</div>
					<div className="col-lg-6">
						<div className="path-content" data-aos="fade-left">
							<h2 className="montserrat path-sub-main-heading">Empowering Girls to <span className="path-block-text montserrat">Lead and Succeed!</span></h2>
							<div className="path-icon-list">
								{pathPoints.map((pt, i) => (
									<div className="path-icon-item" key={i}>
										<div className="path-icon-dot" style={{ background: `linear-gradient(135deg, ${pt.color}, ${pt.color}cc)` }}>
											<i className={pt.icon}></i>
										</div>
										<span>{pt.label}</span>
									</div>
								))}
							</div>
							<Link className="btn explore-btn-about" to="/acadamics">Explore Programs</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Path
